import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDMXFAtzFH8O2O9KN4vApqU0Y0lbAyWzMVs1Q0o9tomClE47nwtE82h+kdJpvto6RBtNQIywywt/NlFdJhnFw/Oo4d7EqkT9C1hgeS8L2rgMDeum5S90xb0VMlhUMvzPRqjA8yQ8fBdAkNfu3YrlVYmTCKrKvkqC9iL14Sh557atQIDAQAB'

const privateKey = '123'

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}

